// Toggle via REACT_APP_USE_MOCK=true
export const USE_MOCK = String(process.env.REACT_APP_USE_MOCK || '').toLowerCase() === 'true';

export const stats = {
  totalUsers: 42,
  totalWebsites: 17,
  openTickets: 5,
};

export const mockSystemActivity = [
  { id: 1, time: '2025-09-03T07:58:00Z', text: 'Nightly backup completed successfully.' },
  { id: 2, time: '2025-09-03T06:30:00Z', text: 'New user registered: jane.doe@example.com' },
  { id: 3, time: '2025-09-02T18:12:00Z', text: 'Website added: https://acme.io' },
];

export const mockSystemLogs = [
  '[INFO] 07:58 Backup finished (duration: 2m10s)',
  '[WARN] 07:02 High DB connections spike',
  '[INFO] 06:30 User signup jane.doe@example.com',
];

export const mockWebsiteLogs = [
  '[INFO] Heatmap job queued for website #3',
  '[INFO] Session recording uploaded for website #7',
  '[ERROR] 404 spike detected on https://example.com',
];

export const mockUsers = [
  { id: 1, name: 'Alice Johnson', email: 'alice@example.com', role: 'super admin' },
  { id: 2, name: 'Bob Smith', email: 'bob@example.com', role: 'admin' },
  { id: 3, name: 'Carol Lee', email: 'carol@example.com', role: 'viewer' },
];

export const mockWebsites = [
  { id: 1, account_id: 10, url: 'https://example.com', status: 'active', created_at: '2025-08-01T10:00:00Z' },
  { id: 2, account_id: 11, url: 'https://acme.io', status: 'active', created_at: '2025-08-12T09:20:00Z' },
  { id: 3, account_id: 12, url: 'https://contoso.org', status: 'inactive', created_at: '2025-08-20T15:45:00Z' },
];

export const mockSnippets = [
  { id: 101, website_id: 1, name: 'Cookie Banner', status: 'active' },
  { id: 102, website_id: 2, name: 'Feedback Widget', status: 'inactive' },
  { id: 103, website_id: 3, name: 'Session Recorder', status: 'active' },
];

export const mockBillingPlans = [
  {
    id: 'free',
    name: 'Free',
    priceMonthly: 0,
    priceYearly: 0,
    currency: 'USD',
    features: ['1 Website', 'Basic Analytics', 'Community Support'],
    recommended: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    priceMonthly: 29,
    priceYearly: 290,
    currency: 'USD',
    features: ['10 Websites', 'Heatmaps & Recordings', 'Email Support'],
    recommended: true,
  },
  {
    id: 'business',
    name: 'Business',
    priceMonthly: 99,
    priceYearly: 990,
    currency: 'USD',
    features: ['Unlimited Websites', 'Advanced Reporting', 'Priority Support'],
    recommended: false,
  },
];
